import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ICountry, getCountryList } from '@/common/constants/country-list';
import { LanguageType } from '@/common/types/general';

export function useCountries(suggestedCountry = 'PT') {
  const { i18n } = useTranslation();
  const countries = useMemo(
    () =>
      getCountryList({
        language: i18n.language as LanguageType,
        suggestedCountryCode: suggestedCountry,
      }),
    [i18n.language, suggestedCountry]
  );

  const getCountryByCode = useCallback(
    (countryCode?: string) => {
      return countries.find((c) => c.iso2 === countryCode);
    },
    [countries]
  );

  const getCountriesByTerm = useCallback(
    (searchTerm?: string) => {
      return countries.filter((c) => {
        return c.name.toLowerCase().includes(searchTerm?.toLowerCase() ?? '');
      });
    },
    [countries]
  );

  const countryMatches = useCallback(
    (country: ICountry, searchTerm: string) => {
      return country.name.toLowerCase().includes(searchTerm.toLowerCase());
    },
    []
  );

  const getCountryName = useCallback(
    (country?: ICountry | null) => country?.name ?? '',
    []
  );

  return {
    countries,
    getCountryName,
    getCountryByCode,
    getCountriesByTerm,
    countryMatches,
  };
}
